const WorkQuotes = () => import('./components/WorkQuotes.vue');
const WorkQuoteList = () => import('./components/WorkQuoteList.vue');
const WorkQuoteForm = () => import('./components/WorkQuoteForm.vue');

export default [
    {
        path: 'quotes',
        component: WorkQuotes,
        meta: {
            group: 'main',
            title: 'Quotes',
            perms: ['work_quote_view']
        },
        children: [
            {
                path: '',
                component: WorkQuoteList,
                name: 'work-quotes',
            },
            {
                path: 'create',
                component: WorkQuoteForm,
                name: 'work-quote-create',
                perms: ['work_quote_manage'],
            },
            {
                path: ':work_quote_number(\\d+)',
                component: WorkQuoteForm,
                name: 'work-quote-show',
                props: true,
            }
        ]
    },
]
